package com.xtream.data_kmp.db.dao

import androidx.room3.EntityDeleteOrUpdateAdapter
import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import com.xtream.data_kmp.db.StringListConverter
import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.dto.ServerInfo
import com.xtream.data_kmp.dto.UserInfo
import kotlin.Boolean
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class UserDao_Impl(
  __db: RoomDatabase,
) : UserDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfAccount: EntityInsertAdapter<Account>

  private val __deleteAdapterOfAccount: EntityDeleteOrUpdateAdapter<Account>

  private val __updateAdapterOfAccount: EntityDeleteOrUpdateAdapter<Account>
  init {
    this.__db = __db
    this.__insertAdapterOfAccount = object : EntityInsertAdapter<Account>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `usersTable` (`isLoggedIn`,`activeCons`,`allowedOutputFormats`,`auth`,`createdAt`,`expDate`,`isTrial`,`maxConnections`,`message`,`password`,`status`,`username`,`token`,`userAgent`,`activationCode`,`httpsPort`,`port`,`rtmpPort`,`serverProtocol`,`timeNow`,`timestampNow`,`timezone`,`url`) VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: Account) {
        val _tmp: Int = if (entity.isLoggedIn) 1 else 0
        statement.bindLong(1, _tmp.toLong())
        val _tmpUserInfo: UserInfo = entity.userInfo
        val _tmpActiveCons: String? = _tmpUserInfo.activeCons
        if (_tmpActiveCons == null) {
          statement.bindNull(2)
        } else {
          statement.bindText(2, _tmpActiveCons)
        }
        val _tmpAllowedOutputFormats: List<String?>? = _tmpUserInfo.allowedOutputFormats
        val _tmp_1: String? = StringListConverter.listToString(_tmpAllowedOutputFormats)
        if (_tmp_1 == null) {
          statement.bindNull(3)
        } else {
          statement.bindText(3, _tmp_1)
        }
        val _tmpAuth: Int? = _tmpUserInfo.auth
        if (_tmpAuth == null) {
          statement.bindNull(4)
        } else {
          statement.bindLong(4, _tmpAuth.toLong())
        }
        val _tmpCreatedAt: String? = _tmpUserInfo.createdAt
        if (_tmpCreatedAt == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpCreatedAt)
        }
        val _tmpExpDate: String? = _tmpUserInfo.expDate
        if (_tmpExpDate == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpExpDate)
        }
        val _tmpIsTrial: String? = _tmpUserInfo.isTrial
        if (_tmpIsTrial == null) {
          statement.bindNull(7)
        } else {
          statement.bindText(7, _tmpIsTrial)
        }
        val _tmpMaxConnections: String? = _tmpUserInfo.maxConnections
        if (_tmpMaxConnections == null) {
          statement.bindNull(8)
        } else {
          statement.bindText(8, _tmpMaxConnections)
        }
        val _tmpMessage: String? = _tmpUserInfo.message
        if (_tmpMessage == null) {
          statement.bindNull(9)
        } else {
          statement.bindText(9, _tmpMessage)
        }
        statement.bindText(10, _tmpUserInfo.password)
        val _tmpStatus: String? = _tmpUserInfo.status
        if (_tmpStatus == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpStatus)
        }
        statement.bindText(12, _tmpUserInfo.username)
        val _tmpToken: String? = _tmpUserInfo.token
        if (_tmpToken == null) {
          statement.bindNull(13)
        } else {
          statement.bindText(13, _tmpToken)
        }
        val _tmpUserAgent: String? = _tmpUserInfo.userAgent
        if (_tmpUserAgent == null) {
          statement.bindNull(14)
        } else {
          statement.bindText(14, _tmpUserAgent)
        }
        val _tmpActivationCode: String? = _tmpUserInfo.activationCode
        if (_tmpActivationCode == null) {
          statement.bindNull(15)
        } else {
          statement.bindText(15, _tmpActivationCode)
        }
        val _tmpServerInfo: ServerInfo = entity.serverInfo
        val _tmpHttpsPort: String? = _tmpServerInfo.httpsPort
        if (_tmpHttpsPort == null) {
          statement.bindNull(16)
        } else {
          statement.bindText(16, _tmpHttpsPort)
        }
        val _tmpPort: String? = _tmpServerInfo.port
        if (_tmpPort == null) {
          statement.bindNull(17)
        } else {
          statement.bindText(17, _tmpPort)
        }
        val _tmpRtmpPort: String? = _tmpServerInfo.rtmpPort
        if (_tmpRtmpPort == null) {
          statement.bindNull(18)
        } else {
          statement.bindText(18, _tmpRtmpPort)
        }
        val _tmpServerProtocol: String? = _tmpServerInfo.serverProtocol
        if (_tmpServerProtocol == null) {
          statement.bindNull(19)
        } else {
          statement.bindText(19, _tmpServerProtocol)
        }
        val _tmpTimeNow: String? = _tmpServerInfo.timeNow
        if (_tmpTimeNow == null) {
          statement.bindNull(20)
        } else {
          statement.bindText(20, _tmpTimeNow)
        }
        val _tmpTimestampNow: Int? = _tmpServerInfo.timestampNow
        if (_tmpTimestampNow == null) {
          statement.bindNull(21)
        } else {
          statement.bindLong(21, _tmpTimestampNow.toLong())
        }
        val _tmpTimezone: String? = _tmpServerInfo.timezone
        if (_tmpTimezone == null) {
          statement.bindNull(22)
        } else {
          statement.bindText(22, _tmpTimezone)
        }
        statement.bindText(23, _tmpServerInfo.url)
      }
    }
    this.__deleteAdapterOfAccount = object : EntityDeleteOrUpdateAdapter<Account>() {
      protected override fun createQuery(): String = "DELETE FROM `usersTable` WHERE `username` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: Account) {
        val _tmpUserInfo: UserInfo = entity.userInfo
        statement.bindText(1, _tmpUserInfo.username)
      }
    }
    this.__updateAdapterOfAccount = object : EntityDeleteOrUpdateAdapter<Account>() {
      protected override fun createQuery(): String = "UPDATE OR REPLACE `usersTable` SET `isLoggedIn` = ?,`activeCons` = ?,`allowedOutputFormats` = ?,`auth` = ?,`createdAt` = ?,`expDate` = ?,`isTrial` = ?,`maxConnections` = ?,`message` = ?,`password` = ?,`status` = ?,`username` = ?,`token` = ?,`userAgent` = ?,`activationCode` = ?,`httpsPort` = ?,`port` = ?,`rtmpPort` = ?,`serverProtocol` = ?,`timeNow` = ?,`timestampNow` = ?,`timezone` = ?,`url` = ? WHERE `username` = ?"

      protected override fun bind(statement: SQLiteStatement, entity: Account) {
        val _tmp: Int = if (entity.isLoggedIn) 1 else 0
        statement.bindLong(1, _tmp.toLong())
        val _tmpUserInfo: UserInfo = entity.userInfo
        val _tmpActiveCons: String? = _tmpUserInfo.activeCons
        if (_tmpActiveCons == null) {
          statement.bindNull(2)
        } else {
          statement.bindText(2, _tmpActiveCons)
        }
        val _tmpAllowedOutputFormats: List<String?>? = _tmpUserInfo.allowedOutputFormats
        val _tmp_1: String? = StringListConverter.listToString(_tmpAllowedOutputFormats)
        if (_tmp_1 == null) {
          statement.bindNull(3)
        } else {
          statement.bindText(3, _tmp_1)
        }
        val _tmpAuth: Int? = _tmpUserInfo.auth
        if (_tmpAuth == null) {
          statement.bindNull(4)
        } else {
          statement.bindLong(4, _tmpAuth.toLong())
        }
        val _tmpCreatedAt: String? = _tmpUserInfo.createdAt
        if (_tmpCreatedAt == null) {
          statement.bindNull(5)
        } else {
          statement.bindText(5, _tmpCreatedAt)
        }
        val _tmpExpDate: String? = _tmpUserInfo.expDate
        if (_tmpExpDate == null) {
          statement.bindNull(6)
        } else {
          statement.bindText(6, _tmpExpDate)
        }
        val _tmpIsTrial: String? = _tmpUserInfo.isTrial
        if (_tmpIsTrial == null) {
          statement.bindNull(7)
        } else {
          statement.bindText(7, _tmpIsTrial)
        }
        val _tmpMaxConnections: String? = _tmpUserInfo.maxConnections
        if (_tmpMaxConnections == null) {
          statement.bindNull(8)
        } else {
          statement.bindText(8, _tmpMaxConnections)
        }
        val _tmpMessage: String? = _tmpUserInfo.message
        if (_tmpMessage == null) {
          statement.bindNull(9)
        } else {
          statement.bindText(9, _tmpMessage)
        }
        statement.bindText(10, _tmpUserInfo.password)
        val _tmpStatus: String? = _tmpUserInfo.status
        if (_tmpStatus == null) {
          statement.bindNull(11)
        } else {
          statement.bindText(11, _tmpStatus)
        }
        statement.bindText(12, _tmpUserInfo.username)
        val _tmpToken: String? = _tmpUserInfo.token
        if (_tmpToken == null) {
          statement.bindNull(13)
        } else {
          statement.bindText(13, _tmpToken)
        }
        val _tmpUserAgent: String? = _tmpUserInfo.userAgent
        if (_tmpUserAgent == null) {
          statement.bindNull(14)
        } else {
          statement.bindText(14, _tmpUserAgent)
        }
        val _tmpActivationCode: String? = _tmpUserInfo.activationCode
        if (_tmpActivationCode == null) {
          statement.bindNull(15)
        } else {
          statement.bindText(15, _tmpActivationCode)
        }
        val _tmpServerInfo: ServerInfo = entity.serverInfo
        val _tmpHttpsPort: String? = _tmpServerInfo.httpsPort
        if (_tmpHttpsPort == null) {
          statement.bindNull(16)
        } else {
          statement.bindText(16, _tmpHttpsPort)
        }
        val _tmpPort: String? = _tmpServerInfo.port
        if (_tmpPort == null) {
          statement.bindNull(17)
        } else {
          statement.bindText(17, _tmpPort)
        }
        val _tmpRtmpPort: String? = _tmpServerInfo.rtmpPort
        if (_tmpRtmpPort == null) {
          statement.bindNull(18)
        } else {
          statement.bindText(18, _tmpRtmpPort)
        }
        val _tmpServerProtocol: String? = _tmpServerInfo.serverProtocol
        if (_tmpServerProtocol == null) {
          statement.bindNull(19)
        } else {
          statement.bindText(19, _tmpServerProtocol)
        }
        val _tmpTimeNow: String? = _tmpServerInfo.timeNow
        if (_tmpTimeNow == null) {
          statement.bindNull(20)
        } else {
          statement.bindText(20, _tmpTimeNow)
        }
        val _tmpTimestampNow: Int? = _tmpServerInfo.timestampNow
        if (_tmpTimestampNow == null) {
          statement.bindNull(21)
        } else {
          statement.bindLong(21, _tmpTimestampNow.toLong())
        }
        val _tmpTimezone: String? = _tmpServerInfo.timezone
        if (_tmpTimezone == null) {
          statement.bindNull(22)
        } else {
          statement.bindText(22, _tmpTimezone)
        }
        statement.bindText(23, _tmpServerInfo.url)
        val _tmpUserInfo_1: UserInfo = entity.userInfo
        statement.bindText(24, _tmpUserInfo_1.username)
      }
    }
  }

  public override suspend fun insertAll(users: List<Account>): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfAccount.insert(_connection, users)
  }

  public override suspend fun insert(user: Account): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfAccount.insert(_connection, user)
  }

  public override suspend fun deleteAll(category: List<Account>): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfAccount.handleMultiple(_connection, category)
  }

  public override suspend fun delete(category: Account): Unit = performSuspending(__db, false, true) { _connection ->
    __deleteAdapterOfAccount.handle(_connection, category)
  }

  public override suspend fun update(user: Account): Unit = performSuspending(__db, false, true) { _connection ->
    __updateAdapterOfAccount.handle(_connection, user)
  }

  public override fun getAllUsersFlow(): Flow<List<Account>> {
    val _sql: String = "SELECT * FROM usersTable"
    return createFlow(__db, false, arrayOf("usersTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfIsLoggedIn: Int = getColumnIndexOrThrow(_stmt, "isLoggedIn")
        val _columnIndexOfActiveCons: Int = getColumnIndexOrThrow(_stmt, "activeCons")
        val _columnIndexOfAllowedOutputFormats: Int = getColumnIndexOrThrow(_stmt, "allowedOutputFormats")
        val _columnIndexOfAuth: Int = getColumnIndexOrThrow(_stmt, "auth")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "createdAt")
        val _columnIndexOfExpDate: Int = getColumnIndexOrThrow(_stmt, "expDate")
        val _columnIndexOfIsTrial: Int = getColumnIndexOrThrow(_stmt, "isTrial")
        val _columnIndexOfMaxConnections: Int = getColumnIndexOrThrow(_stmt, "maxConnections")
        val _columnIndexOfMessage: Int = getColumnIndexOrThrow(_stmt, "message")
        val _columnIndexOfPassword: Int = getColumnIndexOrThrow(_stmt, "password")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfUsername: Int = getColumnIndexOrThrow(_stmt, "username")
        val _columnIndexOfToken: Int = getColumnIndexOrThrow(_stmt, "token")
        val _columnIndexOfUserAgent: Int = getColumnIndexOrThrow(_stmt, "userAgent")
        val _columnIndexOfActivationCode: Int = getColumnIndexOrThrow(_stmt, "activationCode")
        val _columnIndexOfHttpsPort: Int = getColumnIndexOrThrow(_stmt, "httpsPort")
        val _columnIndexOfPort: Int = getColumnIndexOrThrow(_stmt, "port")
        val _columnIndexOfRtmpPort: Int = getColumnIndexOrThrow(_stmt, "rtmpPort")
        val _columnIndexOfServerProtocol: Int = getColumnIndexOrThrow(_stmt, "serverProtocol")
        val _columnIndexOfTimeNow: Int = getColumnIndexOrThrow(_stmt, "timeNow")
        val _columnIndexOfTimestampNow: Int = getColumnIndexOrThrow(_stmt, "timestampNow")
        val _columnIndexOfTimezone: Int = getColumnIndexOrThrow(_stmt, "timezone")
        val _columnIndexOfUrl: Int = getColumnIndexOrThrow(_stmt, "url")
        val _result: MutableList<Account> = mutableListOf()
        while (_stmt.step()) {
          val _item: Account
          val _tmpIsLoggedIn: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfIsLoggedIn).toInt()
          _tmpIsLoggedIn = _tmp != 0
          val _tmpUserInfo: UserInfo
          val _tmpActiveCons: String?
          if (_stmt.isNull(_columnIndexOfActiveCons)) {
            _tmpActiveCons = null
          } else {
            _tmpActiveCons = _stmt.getText(_columnIndexOfActiveCons)
          }
          val _tmpAllowedOutputFormats: List<String?>?
          val _tmp_1: String?
          if (_stmt.isNull(_columnIndexOfAllowedOutputFormats)) {
            _tmp_1 = null
          } else {
            _tmp_1 = _stmt.getText(_columnIndexOfAllowedOutputFormats)
          }
          _tmpAllowedOutputFormats = StringListConverter.stringToList(_tmp_1)
          val _tmpAuth: Int?
          if (_stmt.isNull(_columnIndexOfAuth)) {
            _tmpAuth = null
          } else {
            _tmpAuth = _stmt.getLong(_columnIndexOfAuth).toInt()
          }
          val _tmpCreatedAt: String?
          if (_stmt.isNull(_columnIndexOfCreatedAt)) {
            _tmpCreatedAt = null
          } else {
            _tmpCreatedAt = _stmt.getText(_columnIndexOfCreatedAt)
          }
          val _tmpExpDate: String?
          if (_stmt.isNull(_columnIndexOfExpDate)) {
            _tmpExpDate = null
          } else {
            _tmpExpDate = _stmt.getText(_columnIndexOfExpDate)
          }
          val _tmpIsTrial: String?
          if (_stmt.isNull(_columnIndexOfIsTrial)) {
            _tmpIsTrial = null
          } else {
            _tmpIsTrial = _stmt.getText(_columnIndexOfIsTrial)
          }
          val _tmpMaxConnections: String?
          if (_stmt.isNull(_columnIndexOfMaxConnections)) {
            _tmpMaxConnections = null
          } else {
            _tmpMaxConnections = _stmt.getText(_columnIndexOfMaxConnections)
          }
          val _tmpMessage: String?
          if (_stmt.isNull(_columnIndexOfMessage)) {
            _tmpMessage = null
          } else {
            _tmpMessage = _stmt.getText(_columnIndexOfMessage)
          }
          val _tmpPassword: String
          _tmpPassword = _stmt.getText(_columnIndexOfPassword)
          val _tmpStatus: String?
          if (_stmt.isNull(_columnIndexOfStatus)) {
            _tmpStatus = null
          } else {
            _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          }
          val _tmpUsername: String
          _tmpUsername = _stmt.getText(_columnIndexOfUsername)
          val _tmpToken: String?
          if (_stmt.isNull(_columnIndexOfToken)) {
            _tmpToken = null
          } else {
            _tmpToken = _stmt.getText(_columnIndexOfToken)
          }
          val _tmpUserAgent: String?
          if (_stmt.isNull(_columnIndexOfUserAgent)) {
            _tmpUserAgent = null
          } else {
            _tmpUserAgent = _stmt.getText(_columnIndexOfUserAgent)
          }
          val _tmpActivationCode: String?
          if (_stmt.isNull(_columnIndexOfActivationCode)) {
            _tmpActivationCode = null
          } else {
            _tmpActivationCode = _stmt.getText(_columnIndexOfActivationCode)
          }
          _tmpUserInfo = UserInfo(_tmpActiveCons,_tmpAllowedOutputFormats,_tmpAuth,_tmpCreatedAt,_tmpExpDate,_tmpIsTrial,_tmpMaxConnections,_tmpMessage,_tmpPassword,_tmpStatus,_tmpUsername,_tmpToken,_tmpUserAgent,_tmpActivationCode)
          val _tmpServerInfo: ServerInfo
          val _tmpHttpsPort: String?
          if (_stmt.isNull(_columnIndexOfHttpsPort)) {
            _tmpHttpsPort = null
          } else {
            _tmpHttpsPort = _stmt.getText(_columnIndexOfHttpsPort)
          }
          val _tmpPort: String?
          if (_stmt.isNull(_columnIndexOfPort)) {
            _tmpPort = null
          } else {
            _tmpPort = _stmt.getText(_columnIndexOfPort)
          }
          val _tmpRtmpPort: String?
          if (_stmt.isNull(_columnIndexOfRtmpPort)) {
            _tmpRtmpPort = null
          } else {
            _tmpRtmpPort = _stmt.getText(_columnIndexOfRtmpPort)
          }
          val _tmpServerProtocol: String?
          if (_stmt.isNull(_columnIndexOfServerProtocol)) {
            _tmpServerProtocol = null
          } else {
            _tmpServerProtocol = _stmt.getText(_columnIndexOfServerProtocol)
          }
          val _tmpTimeNow: String?
          if (_stmt.isNull(_columnIndexOfTimeNow)) {
            _tmpTimeNow = null
          } else {
            _tmpTimeNow = _stmt.getText(_columnIndexOfTimeNow)
          }
          val _tmpTimestampNow: Int?
          if (_stmt.isNull(_columnIndexOfTimestampNow)) {
            _tmpTimestampNow = null
          } else {
            _tmpTimestampNow = _stmt.getLong(_columnIndexOfTimestampNow).toInt()
          }
          val _tmpTimezone: String?
          if (_stmt.isNull(_columnIndexOfTimezone)) {
            _tmpTimezone = null
          } else {
            _tmpTimezone = _stmt.getText(_columnIndexOfTimezone)
          }
          val _tmpUrl: String
          _tmpUrl = _stmt.getText(_columnIndexOfUrl)
          _tmpServerInfo = ServerInfo(_tmpHttpsPort,_tmpPort,_tmpRtmpPort,_tmpServerProtocol,_tmpTimeNow,_tmpTimestampNow,_tmpTimezone,_tmpUrl)
          _item = Account(_tmpUserInfo,_tmpServerInfo,_tmpIsLoggedIn)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getAllUsers(): List<Account> {
    val _sql: String = "SELECT * FROM usersTable"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfIsLoggedIn: Int = getColumnIndexOrThrow(_stmt, "isLoggedIn")
        val _columnIndexOfActiveCons: Int = getColumnIndexOrThrow(_stmt, "activeCons")
        val _columnIndexOfAllowedOutputFormats: Int = getColumnIndexOrThrow(_stmt, "allowedOutputFormats")
        val _columnIndexOfAuth: Int = getColumnIndexOrThrow(_stmt, "auth")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "createdAt")
        val _columnIndexOfExpDate: Int = getColumnIndexOrThrow(_stmt, "expDate")
        val _columnIndexOfIsTrial: Int = getColumnIndexOrThrow(_stmt, "isTrial")
        val _columnIndexOfMaxConnections: Int = getColumnIndexOrThrow(_stmt, "maxConnections")
        val _columnIndexOfMessage: Int = getColumnIndexOrThrow(_stmt, "message")
        val _columnIndexOfPassword: Int = getColumnIndexOrThrow(_stmt, "password")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfUsername: Int = getColumnIndexOrThrow(_stmt, "username")
        val _columnIndexOfToken: Int = getColumnIndexOrThrow(_stmt, "token")
        val _columnIndexOfUserAgent: Int = getColumnIndexOrThrow(_stmt, "userAgent")
        val _columnIndexOfActivationCode: Int = getColumnIndexOrThrow(_stmt, "activationCode")
        val _columnIndexOfHttpsPort: Int = getColumnIndexOrThrow(_stmt, "httpsPort")
        val _columnIndexOfPort: Int = getColumnIndexOrThrow(_stmt, "port")
        val _columnIndexOfRtmpPort: Int = getColumnIndexOrThrow(_stmt, "rtmpPort")
        val _columnIndexOfServerProtocol: Int = getColumnIndexOrThrow(_stmt, "serverProtocol")
        val _columnIndexOfTimeNow: Int = getColumnIndexOrThrow(_stmt, "timeNow")
        val _columnIndexOfTimestampNow: Int = getColumnIndexOrThrow(_stmt, "timestampNow")
        val _columnIndexOfTimezone: Int = getColumnIndexOrThrow(_stmt, "timezone")
        val _columnIndexOfUrl: Int = getColumnIndexOrThrow(_stmt, "url")
        val _result: MutableList<Account> = mutableListOf()
        while (_stmt.step()) {
          val _item: Account
          val _tmpIsLoggedIn: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfIsLoggedIn).toInt()
          _tmpIsLoggedIn = _tmp != 0
          val _tmpUserInfo: UserInfo
          val _tmpActiveCons: String?
          if (_stmt.isNull(_columnIndexOfActiveCons)) {
            _tmpActiveCons = null
          } else {
            _tmpActiveCons = _stmt.getText(_columnIndexOfActiveCons)
          }
          val _tmpAllowedOutputFormats: List<String?>?
          val _tmp_1: String?
          if (_stmt.isNull(_columnIndexOfAllowedOutputFormats)) {
            _tmp_1 = null
          } else {
            _tmp_1 = _stmt.getText(_columnIndexOfAllowedOutputFormats)
          }
          _tmpAllowedOutputFormats = StringListConverter.stringToList(_tmp_1)
          val _tmpAuth: Int?
          if (_stmt.isNull(_columnIndexOfAuth)) {
            _tmpAuth = null
          } else {
            _tmpAuth = _stmt.getLong(_columnIndexOfAuth).toInt()
          }
          val _tmpCreatedAt: String?
          if (_stmt.isNull(_columnIndexOfCreatedAt)) {
            _tmpCreatedAt = null
          } else {
            _tmpCreatedAt = _stmt.getText(_columnIndexOfCreatedAt)
          }
          val _tmpExpDate: String?
          if (_stmt.isNull(_columnIndexOfExpDate)) {
            _tmpExpDate = null
          } else {
            _tmpExpDate = _stmt.getText(_columnIndexOfExpDate)
          }
          val _tmpIsTrial: String?
          if (_stmt.isNull(_columnIndexOfIsTrial)) {
            _tmpIsTrial = null
          } else {
            _tmpIsTrial = _stmt.getText(_columnIndexOfIsTrial)
          }
          val _tmpMaxConnections: String?
          if (_stmt.isNull(_columnIndexOfMaxConnections)) {
            _tmpMaxConnections = null
          } else {
            _tmpMaxConnections = _stmt.getText(_columnIndexOfMaxConnections)
          }
          val _tmpMessage: String?
          if (_stmt.isNull(_columnIndexOfMessage)) {
            _tmpMessage = null
          } else {
            _tmpMessage = _stmt.getText(_columnIndexOfMessage)
          }
          val _tmpPassword: String
          _tmpPassword = _stmt.getText(_columnIndexOfPassword)
          val _tmpStatus: String?
          if (_stmt.isNull(_columnIndexOfStatus)) {
            _tmpStatus = null
          } else {
            _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          }
          val _tmpUsername: String
          _tmpUsername = _stmt.getText(_columnIndexOfUsername)
          val _tmpToken: String?
          if (_stmt.isNull(_columnIndexOfToken)) {
            _tmpToken = null
          } else {
            _tmpToken = _stmt.getText(_columnIndexOfToken)
          }
          val _tmpUserAgent: String?
          if (_stmt.isNull(_columnIndexOfUserAgent)) {
            _tmpUserAgent = null
          } else {
            _tmpUserAgent = _stmt.getText(_columnIndexOfUserAgent)
          }
          val _tmpActivationCode: String?
          if (_stmt.isNull(_columnIndexOfActivationCode)) {
            _tmpActivationCode = null
          } else {
            _tmpActivationCode = _stmt.getText(_columnIndexOfActivationCode)
          }
          _tmpUserInfo = UserInfo(_tmpActiveCons,_tmpAllowedOutputFormats,_tmpAuth,_tmpCreatedAt,_tmpExpDate,_tmpIsTrial,_tmpMaxConnections,_tmpMessage,_tmpPassword,_tmpStatus,_tmpUsername,_tmpToken,_tmpUserAgent,_tmpActivationCode)
          val _tmpServerInfo: ServerInfo
          val _tmpHttpsPort: String?
          if (_stmt.isNull(_columnIndexOfHttpsPort)) {
            _tmpHttpsPort = null
          } else {
            _tmpHttpsPort = _stmt.getText(_columnIndexOfHttpsPort)
          }
          val _tmpPort: String?
          if (_stmt.isNull(_columnIndexOfPort)) {
            _tmpPort = null
          } else {
            _tmpPort = _stmt.getText(_columnIndexOfPort)
          }
          val _tmpRtmpPort: String?
          if (_stmt.isNull(_columnIndexOfRtmpPort)) {
            _tmpRtmpPort = null
          } else {
            _tmpRtmpPort = _stmt.getText(_columnIndexOfRtmpPort)
          }
          val _tmpServerProtocol: String?
          if (_stmt.isNull(_columnIndexOfServerProtocol)) {
            _tmpServerProtocol = null
          } else {
            _tmpServerProtocol = _stmt.getText(_columnIndexOfServerProtocol)
          }
          val _tmpTimeNow: String?
          if (_stmt.isNull(_columnIndexOfTimeNow)) {
            _tmpTimeNow = null
          } else {
            _tmpTimeNow = _stmt.getText(_columnIndexOfTimeNow)
          }
          val _tmpTimestampNow: Int?
          if (_stmt.isNull(_columnIndexOfTimestampNow)) {
            _tmpTimestampNow = null
          } else {
            _tmpTimestampNow = _stmt.getLong(_columnIndexOfTimestampNow).toInt()
          }
          val _tmpTimezone: String?
          if (_stmt.isNull(_columnIndexOfTimezone)) {
            _tmpTimezone = null
          } else {
            _tmpTimezone = _stmt.getText(_columnIndexOfTimezone)
          }
          val _tmpUrl: String
          _tmpUrl = _stmt.getText(_columnIndexOfUrl)
          _tmpServerInfo = ServerInfo(_tmpHttpsPort,_tmpPort,_tmpRtmpPort,_tmpServerProtocol,_tmpTimeNow,_tmpTimestampNow,_tmpTimezone,_tmpUrl)
          _item = Account(_tmpUserInfo,_tmpServerInfo,_tmpIsLoggedIn)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getUserByOffset(offset: Int): Account? {
    val _sql: String = "SELECT * FROM usersTable LIMIT 1 OFFSET ?"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindLong(_argIndex, offset.toLong())
        val _columnIndexOfIsLoggedIn: Int = getColumnIndexOrThrow(_stmt, "isLoggedIn")
        val _columnIndexOfActiveCons: Int = getColumnIndexOrThrow(_stmt, "activeCons")
        val _columnIndexOfAllowedOutputFormats: Int = getColumnIndexOrThrow(_stmt, "allowedOutputFormats")
        val _columnIndexOfAuth: Int = getColumnIndexOrThrow(_stmt, "auth")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "createdAt")
        val _columnIndexOfExpDate: Int = getColumnIndexOrThrow(_stmt, "expDate")
        val _columnIndexOfIsTrial: Int = getColumnIndexOrThrow(_stmt, "isTrial")
        val _columnIndexOfMaxConnections: Int = getColumnIndexOrThrow(_stmt, "maxConnections")
        val _columnIndexOfMessage: Int = getColumnIndexOrThrow(_stmt, "message")
        val _columnIndexOfPassword: Int = getColumnIndexOrThrow(_stmt, "password")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfUsername: Int = getColumnIndexOrThrow(_stmt, "username")
        val _columnIndexOfToken: Int = getColumnIndexOrThrow(_stmt, "token")
        val _columnIndexOfUserAgent: Int = getColumnIndexOrThrow(_stmt, "userAgent")
        val _columnIndexOfActivationCode: Int = getColumnIndexOrThrow(_stmt, "activationCode")
        val _columnIndexOfHttpsPort: Int = getColumnIndexOrThrow(_stmt, "httpsPort")
        val _columnIndexOfPort: Int = getColumnIndexOrThrow(_stmt, "port")
        val _columnIndexOfRtmpPort: Int = getColumnIndexOrThrow(_stmt, "rtmpPort")
        val _columnIndexOfServerProtocol: Int = getColumnIndexOrThrow(_stmt, "serverProtocol")
        val _columnIndexOfTimeNow: Int = getColumnIndexOrThrow(_stmt, "timeNow")
        val _columnIndexOfTimestampNow: Int = getColumnIndexOrThrow(_stmt, "timestampNow")
        val _columnIndexOfTimezone: Int = getColumnIndexOrThrow(_stmt, "timezone")
        val _columnIndexOfUrl: Int = getColumnIndexOrThrow(_stmt, "url")
        val _result: Account?
        if (_stmt.step()) {
          val _tmpIsLoggedIn: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfIsLoggedIn).toInt()
          _tmpIsLoggedIn = _tmp != 0
          val _tmpUserInfo: UserInfo
          val _tmpActiveCons: String?
          if (_stmt.isNull(_columnIndexOfActiveCons)) {
            _tmpActiveCons = null
          } else {
            _tmpActiveCons = _stmt.getText(_columnIndexOfActiveCons)
          }
          val _tmpAllowedOutputFormats: List<String?>?
          val _tmp_1: String?
          if (_stmt.isNull(_columnIndexOfAllowedOutputFormats)) {
            _tmp_1 = null
          } else {
            _tmp_1 = _stmt.getText(_columnIndexOfAllowedOutputFormats)
          }
          _tmpAllowedOutputFormats = StringListConverter.stringToList(_tmp_1)
          val _tmpAuth: Int?
          if (_stmt.isNull(_columnIndexOfAuth)) {
            _tmpAuth = null
          } else {
            _tmpAuth = _stmt.getLong(_columnIndexOfAuth).toInt()
          }
          val _tmpCreatedAt: String?
          if (_stmt.isNull(_columnIndexOfCreatedAt)) {
            _tmpCreatedAt = null
          } else {
            _tmpCreatedAt = _stmt.getText(_columnIndexOfCreatedAt)
          }
          val _tmpExpDate: String?
          if (_stmt.isNull(_columnIndexOfExpDate)) {
            _tmpExpDate = null
          } else {
            _tmpExpDate = _stmt.getText(_columnIndexOfExpDate)
          }
          val _tmpIsTrial: String?
          if (_stmt.isNull(_columnIndexOfIsTrial)) {
            _tmpIsTrial = null
          } else {
            _tmpIsTrial = _stmt.getText(_columnIndexOfIsTrial)
          }
          val _tmpMaxConnections: String?
          if (_stmt.isNull(_columnIndexOfMaxConnections)) {
            _tmpMaxConnections = null
          } else {
            _tmpMaxConnections = _stmt.getText(_columnIndexOfMaxConnections)
          }
          val _tmpMessage: String?
          if (_stmt.isNull(_columnIndexOfMessage)) {
            _tmpMessage = null
          } else {
            _tmpMessage = _stmt.getText(_columnIndexOfMessage)
          }
          val _tmpPassword: String
          _tmpPassword = _stmt.getText(_columnIndexOfPassword)
          val _tmpStatus: String?
          if (_stmt.isNull(_columnIndexOfStatus)) {
            _tmpStatus = null
          } else {
            _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          }
          val _tmpUsername: String
          _tmpUsername = _stmt.getText(_columnIndexOfUsername)
          val _tmpToken: String?
          if (_stmt.isNull(_columnIndexOfToken)) {
            _tmpToken = null
          } else {
            _tmpToken = _stmt.getText(_columnIndexOfToken)
          }
          val _tmpUserAgent: String?
          if (_stmt.isNull(_columnIndexOfUserAgent)) {
            _tmpUserAgent = null
          } else {
            _tmpUserAgent = _stmt.getText(_columnIndexOfUserAgent)
          }
          val _tmpActivationCode: String?
          if (_stmt.isNull(_columnIndexOfActivationCode)) {
            _tmpActivationCode = null
          } else {
            _tmpActivationCode = _stmt.getText(_columnIndexOfActivationCode)
          }
          _tmpUserInfo = UserInfo(_tmpActiveCons,_tmpAllowedOutputFormats,_tmpAuth,_tmpCreatedAt,_tmpExpDate,_tmpIsTrial,_tmpMaxConnections,_tmpMessage,_tmpPassword,_tmpStatus,_tmpUsername,_tmpToken,_tmpUserAgent,_tmpActivationCode)
          val _tmpServerInfo: ServerInfo
          val _tmpHttpsPort: String?
          if (_stmt.isNull(_columnIndexOfHttpsPort)) {
            _tmpHttpsPort = null
          } else {
            _tmpHttpsPort = _stmt.getText(_columnIndexOfHttpsPort)
          }
          val _tmpPort: String?
          if (_stmt.isNull(_columnIndexOfPort)) {
            _tmpPort = null
          } else {
            _tmpPort = _stmt.getText(_columnIndexOfPort)
          }
          val _tmpRtmpPort: String?
          if (_stmt.isNull(_columnIndexOfRtmpPort)) {
            _tmpRtmpPort = null
          } else {
            _tmpRtmpPort = _stmt.getText(_columnIndexOfRtmpPort)
          }
          val _tmpServerProtocol: String?
          if (_stmt.isNull(_columnIndexOfServerProtocol)) {
            _tmpServerProtocol = null
          } else {
            _tmpServerProtocol = _stmt.getText(_columnIndexOfServerProtocol)
          }
          val _tmpTimeNow: String?
          if (_stmt.isNull(_columnIndexOfTimeNow)) {
            _tmpTimeNow = null
          } else {
            _tmpTimeNow = _stmt.getText(_columnIndexOfTimeNow)
          }
          val _tmpTimestampNow: Int?
          if (_stmt.isNull(_columnIndexOfTimestampNow)) {
            _tmpTimestampNow = null
          } else {
            _tmpTimestampNow = _stmt.getLong(_columnIndexOfTimestampNow).toInt()
          }
          val _tmpTimezone: String?
          if (_stmt.isNull(_columnIndexOfTimezone)) {
            _tmpTimezone = null
          } else {
            _tmpTimezone = _stmt.getText(_columnIndexOfTimezone)
          }
          val _tmpUrl: String
          _tmpUrl = _stmt.getText(_columnIndexOfUrl)
          _tmpServerInfo = ServerInfo(_tmpHttpsPort,_tmpPort,_tmpRtmpPort,_tmpServerProtocol,_tmpTimeNow,_tmpTimestampNow,_tmpTimezone,_tmpUrl)
          _result = Account(_tmpUserInfo,_tmpServerInfo,_tmpIsLoggedIn)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getSize(): Long? {
    val _sql: String = "SELECT COUNT(*) FROM usersTable"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _result: Long?
        if (_stmt.step()) {
          val _tmp: Long?
          if (_stmt.isNull(0)) {
            _tmp = null
          } else {
            _tmp = _stmt.getLong(0)
          }
          _result = _tmp
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun getLoggedInUser(): Account? {
    val _sql: String = "SELECT * FROM usersTable WHERE isLoggedIn = 1 LIMIT 1"
    return performSuspending(__db, true, false) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfIsLoggedIn: Int = getColumnIndexOrThrow(_stmt, "isLoggedIn")
        val _columnIndexOfActiveCons: Int = getColumnIndexOrThrow(_stmt, "activeCons")
        val _columnIndexOfAllowedOutputFormats: Int = getColumnIndexOrThrow(_stmt, "allowedOutputFormats")
        val _columnIndexOfAuth: Int = getColumnIndexOrThrow(_stmt, "auth")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "createdAt")
        val _columnIndexOfExpDate: Int = getColumnIndexOrThrow(_stmt, "expDate")
        val _columnIndexOfIsTrial: Int = getColumnIndexOrThrow(_stmt, "isTrial")
        val _columnIndexOfMaxConnections: Int = getColumnIndexOrThrow(_stmt, "maxConnections")
        val _columnIndexOfMessage: Int = getColumnIndexOrThrow(_stmt, "message")
        val _columnIndexOfPassword: Int = getColumnIndexOrThrow(_stmt, "password")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfUsername: Int = getColumnIndexOrThrow(_stmt, "username")
        val _columnIndexOfToken: Int = getColumnIndexOrThrow(_stmt, "token")
        val _columnIndexOfUserAgent: Int = getColumnIndexOrThrow(_stmt, "userAgent")
        val _columnIndexOfActivationCode: Int = getColumnIndexOrThrow(_stmt, "activationCode")
        val _columnIndexOfHttpsPort: Int = getColumnIndexOrThrow(_stmt, "httpsPort")
        val _columnIndexOfPort: Int = getColumnIndexOrThrow(_stmt, "port")
        val _columnIndexOfRtmpPort: Int = getColumnIndexOrThrow(_stmt, "rtmpPort")
        val _columnIndexOfServerProtocol: Int = getColumnIndexOrThrow(_stmt, "serverProtocol")
        val _columnIndexOfTimeNow: Int = getColumnIndexOrThrow(_stmt, "timeNow")
        val _columnIndexOfTimestampNow: Int = getColumnIndexOrThrow(_stmt, "timestampNow")
        val _columnIndexOfTimezone: Int = getColumnIndexOrThrow(_stmt, "timezone")
        val _columnIndexOfUrl: Int = getColumnIndexOrThrow(_stmt, "url")
        val _result: Account?
        if (_stmt.step()) {
          val _tmpIsLoggedIn: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfIsLoggedIn).toInt()
          _tmpIsLoggedIn = _tmp != 0
          val _tmpUserInfo: UserInfo
          val _tmpActiveCons: String?
          if (_stmt.isNull(_columnIndexOfActiveCons)) {
            _tmpActiveCons = null
          } else {
            _tmpActiveCons = _stmt.getText(_columnIndexOfActiveCons)
          }
          val _tmpAllowedOutputFormats: List<String?>?
          val _tmp_1: String?
          if (_stmt.isNull(_columnIndexOfAllowedOutputFormats)) {
            _tmp_1 = null
          } else {
            _tmp_1 = _stmt.getText(_columnIndexOfAllowedOutputFormats)
          }
          _tmpAllowedOutputFormats = StringListConverter.stringToList(_tmp_1)
          val _tmpAuth: Int?
          if (_stmt.isNull(_columnIndexOfAuth)) {
            _tmpAuth = null
          } else {
            _tmpAuth = _stmt.getLong(_columnIndexOfAuth).toInt()
          }
          val _tmpCreatedAt: String?
          if (_stmt.isNull(_columnIndexOfCreatedAt)) {
            _tmpCreatedAt = null
          } else {
            _tmpCreatedAt = _stmt.getText(_columnIndexOfCreatedAt)
          }
          val _tmpExpDate: String?
          if (_stmt.isNull(_columnIndexOfExpDate)) {
            _tmpExpDate = null
          } else {
            _tmpExpDate = _stmt.getText(_columnIndexOfExpDate)
          }
          val _tmpIsTrial: String?
          if (_stmt.isNull(_columnIndexOfIsTrial)) {
            _tmpIsTrial = null
          } else {
            _tmpIsTrial = _stmt.getText(_columnIndexOfIsTrial)
          }
          val _tmpMaxConnections: String?
          if (_stmt.isNull(_columnIndexOfMaxConnections)) {
            _tmpMaxConnections = null
          } else {
            _tmpMaxConnections = _stmt.getText(_columnIndexOfMaxConnections)
          }
          val _tmpMessage: String?
          if (_stmt.isNull(_columnIndexOfMessage)) {
            _tmpMessage = null
          } else {
            _tmpMessage = _stmt.getText(_columnIndexOfMessage)
          }
          val _tmpPassword: String
          _tmpPassword = _stmt.getText(_columnIndexOfPassword)
          val _tmpStatus: String?
          if (_stmt.isNull(_columnIndexOfStatus)) {
            _tmpStatus = null
          } else {
            _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          }
          val _tmpUsername: String
          _tmpUsername = _stmt.getText(_columnIndexOfUsername)
          val _tmpToken: String?
          if (_stmt.isNull(_columnIndexOfToken)) {
            _tmpToken = null
          } else {
            _tmpToken = _stmt.getText(_columnIndexOfToken)
          }
          val _tmpUserAgent: String?
          if (_stmt.isNull(_columnIndexOfUserAgent)) {
            _tmpUserAgent = null
          } else {
            _tmpUserAgent = _stmt.getText(_columnIndexOfUserAgent)
          }
          val _tmpActivationCode: String?
          if (_stmt.isNull(_columnIndexOfActivationCode)) {
            _tmpActivationCode = null
          } else {
            _tmpActivationCode = _stmt.getText(_columnIndexOfActivationCode)
          }
          _tmpUserInfo = UserInfo(_tmpActiveCons,_tmpAllowedOutputFormats,_tmpAuth,_tmpCreatedAt,_tmpExpDate,_tmpIsTrial,_tmpMaxConnections,_tmpMessage,_tmpPassword,_tmpStatus,_tmpUsername,_tmpToken,_tmpUserAgent,_tmpActivationCode)
          val _tmpServerInfo: ServerInfo
          val _tmpHttpsPort: String?
          if (_stmt.isNull(_columnIndexOfHttpsPort)) {
            _tmpHttpsPort = null
          } else {
            _tmpHttpsPort = _stmt.getText(_columnIndexOfHttpsPort)
          }
          val _tmpPort: String?
          if (_stmt.isNull(_columnIndexOfPort)) {
            _tmpPort = null
          } else {
            _tmpPort = _stmt.getText(_columnIndexOfPort)
          }
          val _tmpRtmpPort: String?
          if (_stmt.isNull(_columnIndexOfRtmpPort)) {
            _tmpRtmpPort = null
          } else {
            _tmpRtmpPort = _stmt.getText(_columnIndexOfRtmpPort)
          }
          val _tmpServerProtocol: String?
          if (_stmt.isNull(_columnIndexOfServerProtocol)) {
            _tmpServerProtocol = null
          } else {
            _tmpServerProtocol = _stmt.getText(_columnIndexOfServerProtocol)
          }
          val _tmpTimeNow: String?
          if (_stmt.isNull(_columnIndexOfTimeNow)) {
            _tmpTimeNow = null
          } else {
            _tmpTimeNow = _stmt.getText(_columnIndexOfTimeNow)
          }
          val _tmpTimestampNow: Int?
          if (_stmt.isNull(_columnIndexOfTimestampNow)) {
            _tmpTimestampNow = null
          } else {
            _tmpTimestampNow = _stmt.getLong(_columnIndexOfTimestampNow).toInt()
          }
          val _tmpTimezone: String?
          if (_stmt.isNull(_columnIndexOfTimezone)) {
            _tmpTimezone = null
          } else {
            _tmpTimezone = _stmt.getText(_columnIndexOfTimezone)
          }
          val _tmpUrl: String
          _tmpUrl = _stmt.getText(_columnIndexOfUrl)
          _tmpServerInfo = ServerInfo(_tmpHttpsPort,_tmpPort,_tmpRtmpPort,_tmpServerProtocol,_tmpTimeNow,_tmpTimestampNow,_tmpTimezone,_tmpUrl)
          _result = Account(_tmpUserInfo,_tmpServerInfo,_tmpIsLoggedIn)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override fun getLoggedInUserFlow(): Flow<Account?> {
    val _sql: String = "SELECT * FROM usersTable WHERE isLoggedIn = 1 LIMIT 1"
    return createFlow(__db, false, arrayOf("usersTable")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        val _columnIndexOfIsLoggedIn: Int = getColumnIndexOrThrow(_stmt, "isLoggedIn")
        val _columnIndexOfActiveCons: Int = getColumnIndexOrThrow(_stmt, "activeCons")
        val _columnIndexOfAllowedOutputFormats: Int = getColumnIndexOrThrow(_stmt, "allowedOutputFormats")
        val _columnIndexOfAuth: Int = getColumnIndexOrThrow(_stmt, "auth")
        val _columnIndexOfCreatedAt: Int = getColumnIndexOrThrow(_stmt, "createdAt")
        val _columnIndexOfExpDate: Int = getColumnIndexOrThrow(_stmt, "expDate")
        val _columnIndexOfIsTrial: Int = getColumnIndexOrThrow(_stmt, "isTrial")
        val _columnIndexOfMaxConnections: Int = getColumnIndexOrThrow(_stmt, "maxConnections")
        val _columnIndexOfMessage: Int = getColumnIndexOrThrow(_stmt, "message")
        val _columnIndexOfPassword: Int = getColumnIndexOrThrow(_stmt, "password")
        val _columnIndexOfStatus: Int = getColumnIndexOrThrow(_stmt, "status")
        val _columnIndexOfUsername: Int = getColumnIndexOrThrow(_stmt, "username")
        val _columnIndexOfToken: Int = getColumnIndexOrThrow(_stmt, "token")
        val _columnIndexOfUserAgent: Int = getColumnIndexOrThrow(_stmt, "userAgent")
        val _columnIndexOfActivationCode: Int = getColumnIndexOrThrow(_stmt, "activationCode")
        val _columnIndexOfHttpsPort: Int = getColumnIndexOrThrow(_stmt, "httpsPort")
        val _columnIndexOfPort: Int = getColumnIndexOrThrow(_stmt, "port")
        val _columnIndexOfRtmpPort: Int = getColumnIndexOrThrow(_stmt, "rtmpPort")
        val _columnIndexOfServerProtocol: Int = getColumnIndexOrThrow(_stmt, "serverProtocol")
        val _columnIndexOfTimeNow: Int = getColumnIndexOrThrow(_stmt, "timeNow")
        val _columnIndexOfTimestampNow: Int = getColumnIndexOrThrow(_stmt, "timestampNow")
        val _columnIndexOfTimezone: Int = getColumnIndexOrThrow(_stmt, "timezone")
        val _columnIndexOfUrl: Int = getColumnIndexOrThrow(_stmt, "url")
        val _result: Account?
        if (_stmt.step()) {
          val _tmpIsLoggedIn: Boolean
          val _tmp: Int
          _tmp = _stmt.getLong(_columnIndexOfIsLoggedIn).toInt()
          _tmpIsLoggedIn = _tmp != 0
          val _tmpUserInfo: UserInfo
          val _tmpActiveCons: String?
          if (_stmt.isNull(_columnIndexOfActiveCons)) {
            _tmpActiveCons = null
          } else {
            _tmpActiveCons = _stmt.getText(_columnIndexOfActiveCons)
          }
          val _tmpAllowedOutputFormats: List<String?>?
          val _tmp_1: String?
          if (_stmt.isNull(_columnIndexOfAllowedOutputFormats)) {
            _tmp_1 = null
          } else {
            _tmp_1 = _stmt.getText(_columnIndexOfAllowedOutputFormats)
          }
          _tmpAllowedOutputFormats = StringListConverter.stringToList(_tmp_1)
          val _tmpAuth: Int?
          if (_stmt.isNull(_columnIndexOfAuth)) {
            _tmpAuth = null
          } else {
            _tmpAuth = _stmt.getLong(_columnIndexOfAuth).toInt()
          }
          val _tmpCreatedAt: String?
          if (_stmt.isNull(_columnIndexOfCreatedAt)) {
            _tmpCreatedAt = null
          } else {
            _tmpCreatedAt = _stmt.getText(_columnIndexOfCreatedAt)
          }
          val _tmpExpDate: String?
          if (_stmt.isNull(_columnIndexOfExpDate)) {
            _tmpExpDate = null
          } else {
            _tmpExpDate = _stmt.getText(_columnIndexOfExpDate)
          }
          val _tmpIsTrial: String?
          if (_stmt.isNull(_columnIndexOfIsTrial)) {
            _tmpIsTrial = null
          } else {
            _tmpIsTrial = _stmt.getText(_columnIndexOfIsTrial)
          }
          val _tmpMaxConnections: String?
          if (_stmt.isNull(_columnIndexOfMaxConnections)) {
            _tmpMaxConnections = null
          } else {
            _tmpMaxConnections = _stmt.getText(_columnIndexOfMaxConnections)
          }
          val _tmpMessage: String?
          if (_stmt.isNull(_columnIndexOfMessage)) {
            _tmpMessage = null
          } else {
            _tmpMessage = _stmt.getText(_columnIndexOfMessage)
          }
          val _tmpPassword: String
          _tmpPassword = _stmt.getText(_columnIndexOfPassword)
          val _tmpStatus: String?
          if (_stmt.isNull(_columnIndexOfStatus)) {
            _tmpStatus = null
          } else {
            _tmpStatus = _stmt.getText(_columnIndexOfStatus)
          }
          val _tmpUsername: String
          _tmpUsername = _stmt.getText(_columnIndexOfUsername)
          val _tmpToken: String?
          if (_stmt.isNull(_columnIndexOfToken)) {
            _tmpToken = null
          } else {
            _tmpToken = _stmt.getText(_columnIndexOfToken)
          }
          val _tmpUserAgent: String?
          if (_stmt.isNull(_columnIndexOfUserAgent)) {
            _tmpUserAgent = null
          } else {
            _tmpUserAgent = _stmt.getText(_columnIndexOfUserAgent)
          }
          val _tmpActivationCode: String?
          if (_stmt.isNull(_columnIndexOfActivationCode)) {
            _tmpActivationCode = null
          } else {
            _tmpActivationCode = _stmt.getText(_columnIndexOfActivationCode)
          }
          _tmpUserInfo = UserInfo(_tmpActiveCons,_tmpAllowedOutputFormats,_tmpAuth,_tmpCreatedAt,_tmpExpDate,_tmpIsTrial,_tmpMaxConnections,_tmpMessage,_tmpPassword,_tmpStatus,_tmpUsername,_tmpToken,_tmpUserAgent,_tmpActivationCode)
          val _tmpServerInfo: ServerInfo
          val _tmpHttpsPort: String?
          if (_stmt.isNull(_columnIndexOfHttpsPort)) {
            _tmpHttpsPort = null
          } else {
            _tmpHttpsPort = _stmt.getText(_columnIndexOfHttpsPort)
          }
          val _tmpPort: String?
          if (_stmt.isNull(_columnIndexOfPort)) {
            _tmpPort = null
          } else {
            _tmpPort = _stmt.getText(_columnIndexOfPort)
          }
          val _tmpRtmpPort: String?
          if (_stmt.isNull(_columnIndexOfRtmpPort)) {
            _tmpRtmpPort = null
          } else {
            _tmpRtmpPort = _stmt.getText(_columnIndexOfRtmpPort)
          }
          val _tmpServerProtocol: String?
          if (_stmt.isNull(_columnIndexOfServerProtocol)) {
            _tmpServerProtocol = null
          } else {
            _tmpServerProtocol = _stmt.getText(_columnIndexOfServerProtocol)
          }
          val _tmpTimeNow: String?
          if (_stmt.isNull(_columnIndexOfTimeNow)) {
            _tmpTimeNow = null
          } else {
            _tmpTimeNow = _stmt.getText(_columnIndexOfTimeNow)
          }
          val _tmpTimestampNow: Int?
          if (_stmt.isNull(_columnIndexOfTimestampNow)) {
            _tmpTimestampNow = null
          } else {
            _tmpTimestampNow = _stmt.getLong(_columnIndexOfTimestampNow).toInt()
          }
          val _tmpTimezone: String?
          if (_stmt.isNull(_columnIndexOfTimezone)) {
            _tmpTimezone = null
          } else {
            _tmpTimezone = _stmt.getText(_columnIndexOfTimezone)
          }
          val _tmpUrl: String
          _tmpUrl = _stmt.getText(_columnIndexOfUrl)
          _tmpServerInfo = ServerInfo(_tmpHttpsPort,_tmpPort,_tmpRtmpPort,_tmpServerProtocol,_tmpTimeNow,_tmpTimestampNow,_tmpTimezone,_tmpUrl)
          _result = Account(_tmpUserInfo,_tmpServerInfo,_tmpIsLoggedIn)
        } else {
          _result = null
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun deleteAll() {
    val _sql: String = "DELETE FROM usersTable"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun logoutAllUsers() {
    val _sql: String = "UPDATE usersTable SET isLoggedIn = 0"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
